/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useHistory } from "react-router-dom";
import { ModalConfirm } from "@nordcloud/gnui";
import { ROUTES } from "~/routing/routes";
import { showError, showSuccess } from "~/services/toast";
import { useDeletePlan } from "~/views/plans/hooks";

type Props = {
  planId: string;
  isDeleteModalOpen: boolean;
  onClose: () => void;
  displayPlanList?: boolean;
};

export function DeletePlan({
  planId,
  isDeleteModalOpen,
  onClose,
  displayPlanList,
}: Props) {
  const history = useHistory();

  const [removePlan] = useDeletePlan({
    onSuccess: () => {
      onClose();
      if (displayPlanList) {
        history.push(ROUTES.plans.index);
      }
    },
  });

  function deletePlan(id: string) {
    removePlan(id)
      .then(() => showSuccess(`Plan has been deleted.`))
      .catch(() => showError());
  }

  return (
    <ModalConfirm
      onClose={onClose}
      isOpen={isDeleteModalOpen}
      confirm={() => deletePlan(planId)}
      actionLabel="Delete"
      contentLabel={`Delete Plan`}
    >
      {`Are you sure you want to delete Plan?`}
    </ModalConfirm>
  );
}
